import { Form } from '@unform/web';
import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.section`
  display: flex;
  align-items: flex-start;
  column-gap: 6.4rem;
  row-gap: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    align-items: center;
    margin: 1.6rem auto;
    width: 90%;
  }
`;

export const EnableExercise = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 383px;
  padding: 2.4rem;
  background: #fff;
  border-radius: 0.6rem;
`;

export const EnableExerciseTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 1.6rem;

  @media (max-width: ${breakpoints.medium}) {
    text-align: center;
  }
`;

export const EnableExerciseForm = styled(Form)``;

export const Content = styled.section`
  width: 100%;
  max-width: 680px;
  max-height: 70.2rem;
  padding: 2.4rem;
  overflow-y: auto;

  /* &::-webkit-scrollbar {
    display: none;
  } */

  background: #fff;
  border-radius: 0.6rem;
`;

export const Title = styled.h2`
  font-size: 2.8rem;
  color: #0f0f0f;
  letter-spacing: 0.168rem;
  text-transform: uppercase;

  @media (max-width: ${breakpoints.medium}) {
    text-align: center;
  }
`;

export const Header = styled.section`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const InfosContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 3.2rem;
  column-gap: 6.4rem;
`;

export const InfosItem = styled.div`
  font-size: 1.4rem;
`;

export const InfosItemTitle = styled.h3`
  margin-bottom: 1.6rem;
`;

export const InfosItemValue = styled.p``;

export const Footer = styled.section`
  display: flex;
  justify-content: flex-start;
  margin-top: 2.4rem;
  gap: 1.6rem;
`;
